export default __webpack_public_path__ + "static/media/04_folklor_sieradzki.ca0132bb.png";